var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex p10 bg-white"},[_c('div',{staticClass:"w70 f13 f-grey pt10"},[_vm._v(_vm._s(_vm.name || _vm.label))]),_c('div',{staticClass:"flex-1"},[_c('FaImageUpload',_vm._b({attrs:{"maxCount":1},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'FaImageUpload',_vm.mOptions,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }